module.exports = __webpack_public_path__ + "img/multiline.b474ad1d.png";